export default [
  'default',
  'tiny',
  'small',
  'medium',
  'large',
  'extraLarge',
];
